/* LinksRenderer.js */

"use strict";
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;
const _ = require("lodash");
//const _ = require('lodash');

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;
        this._popUpWidget = undefined;

        this._networkDiscoveryLogIcon = document.createElement("actionable-icon-gl");
        this._networkDiscoveryLogIcon.dataset.icon = "common.log_link";
        this._networkDiscoveryLogIcon.setAttribute("title", "Logs");

        this._rootElem.appendChild(this._networkDiscoveryLogIcon);
        this._logFile = document.createElement("log-display-gl");

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._networkDiscoveryLogIcon.remove();
            this._networkDiscoveryLogIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._popUpWidget = undefined;
            this._logFile = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
        this._model.on("LogsAdded", (this._onLogsAdded = this._onLogsAdded.bind(this)));

        this._model.on("LogAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
        this._model.on("LogCreated", (this.onLogCreated = this.onLogCreated.bind(this)));
    }

    _registerPopUpListener() {
        this._popUpWidget.on("PopUpVisible", (this._onContent = this._onContent.bind(this)));
    }

    _onContent() {
        if (!this._model._logsRendered) {
            this._model.getLogs(this._model._value);
        } else {
            this._scrollToEnd();
        }
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Links");
        this._model.removeAllListeners("LogsAdded");

        this._model.removeAllListeners("LogAdded");

        this._model.removeAllListeners("LogCreated");
    }

    _setLogData(empty) {
        if (this._rootElem === null) {
            return;
        }
        if (_.isEmpty(this._popUpWidget)) {
            let viewexecutionPlanElement = document.createElement("view-more-pop-up");
            viewexecutionPlanElement.classList.add("results-log-popup");
            viewexecutionPlanElement.innerHTML = this._getToolTipContent(empty);
            this._popUpWidget = new PopUpWidget({
                content: viewexecutionPlanElement.outerHTML,
                anchor: this._networkDiscoveryLogIcon,
                anchorPoint: "left",
                displayDirection: "bottomLeft",
                openOnHover: true,
                parent: viewexecutionPlanElement.parentNode
            });

            this._registerPopUpListener();
        }
    }

    onLogCreated() {
        this._setLogData();
    }

    resetTooltipContent() {
        let viewexecutionPlanElement = document.createElement("view-more-pop-up");
        viewexecutionPlanElement.classList.add("results-log-popup");
        viewexecutionPlanElement.innerHTML = this._getToolTipContent();
        this._popUpWidget.setContent(viewexecutionPlanElement.outerHTML); // Doing it the right way

        this._scrollToEnd();
    }

    _getToolTipContent(empty) {
        const logHtml = empty ? "Loading..." : this._logFile.outerHTML;
        return `<span class="arrow"><i></i></span><div class="main-container p-b-0">${logHtml}</div>`;
    }
    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setLinks(this._model.getLinks());
        this._setLogData(true);
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._setLinks(newVal);
    }

    _onLogsAdded(logs) {
        this._setLogData();
        this._setLogs(logs);
    }

    _onLogAdded(logs) {
        this._setLogData();
        this._setLogs([logs]);
        this.resetTooltipContent();
    }

    _setLogs(logs) {
        // if (!_.isEmpty(logs) && logs.length >= 200) {
        //     logs = logs.slice(Math.max(logs.length - 201, 1));
        // }

        let wrapper = document.createElement("div");

        _.forEach(logs, (log) => {
            if (Object.values(log).length > 0) {
                _.forEach(Object.values(log), (eachLog) => {
                    wrapper.appendChild(this._createLogItem(eachLog));
                });
            } else {
                wrapper.appendChild(this._createLogItem(log));
            }
        });
        if (_.isEmpty(logs)) {
            let emptyMsg = document.createElement("span");
            emptyMsg.innerHTML = "No device logs available";
            wrapper.appendChild(emptyMsg);
        }

        // For individual logs being added from feed
        // if (_.get(this._logFile, "childElementCount", 0) === 201) {
        //     _.get(this._logFile, "children.0", 0).remove();
        // }
        this._logFile.innerHTML = "";
        this._logFile.appendChild(wrapper);
    }

    _createLogItem(log) {
        let logEntry = document.createElement("p");

        let logLineNumber = document.createElement("span");
        logLineNumber.classList.add("log-line-number");
        logLineNumber.innerText = _.get(log, "lln", "");

        let timestamp = _.get(log, "time", "");
        let fileTimeStamp = timestamp;

        if (timestamp) {
            fileTimeStamp = Date.create(timestamp).format("{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{fff}");
            timestamp = Date.create(timestamp).format("{HH}:{mm}:{ss}.{fff}");
        }

        let time = document.createElement("span");
        time.classList.add("timestamp");
        time.innerText = timestamp;
        if (!this._logFileStarttime) {
            this._logFileStarttime = fileTimeStamp;
        }
        let level = document.createElement("span");
        level.classList.add("level");
        let lvl = "";
        if (_.get(log, "resp", "")) {
            lvl = "RESP";
        } else if (_.get(log, "eventType", false)) {
            if (_.get(log, "eventType") === "START" || _.get(log, "eventType") === "FINISH") {
                lvl = _.get(log, "eventType");
            } else {
                lvl = "EVENT";
            }
        }
        level.innerText = lvl;

        let message = document.createElement("span");
        message.classList.add("message");
        message.innerText = _.get(log, "msg", _.get(log, "resp", ""));

        logEntry.appendChild(logLineNumber);
        logEntry.appendChild(time);
        logEntry.appendChild(level);
        logEntry.appendChild(message);
        return logEntry;
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLinks(/*newVal*/) {
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._networkDiscoveryLogIcon);
    }

    _scrollToEnd() {
        const _viewMorePopUpContainer = document.querySelectorAll("view-more-pop-up");
        if (!_.isEmpty(_viewMorePopUpContainer)) {
            _viewMorePopUpContainer.forEach((currentContainer) => {
                currentContainer.scrollTop = currentContainer.scrollHeight;
            });
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
